export default "__VITE_ASSET__BzWANIpQ__"